'use client';
import { Button, Flex, Text } from '@chakra-ui/react';
import { useQueryErrorResetBoundary } from '@tanstack/react-query';
import { Suspense, type ReactElement, type ReactNode } from 'react';
import LucideIcon from './LucideIcon';
import { ErrorBoundary } from '@/utils/react';

interface QueryBoundaryProps {
  children: ReactNode;
  loadingFallback?: ReactElement;
  errorFallback?: ReactElement;
}

export const DefaultErrorFallback = ({ resetBoundary }: { resetBoundary?: () => void }) => {
  return (
    <Flex direction="column" align="center" gap={4}>
      <Text textStyle="body2" fontWeight="bold">
        Something went wrong
      </Text>
      <Button value="primary" colorPalette="brand" onClick={resetBoundary}>
        <LucideIcon name="RefreshCcwIcon" boxSize={4} />
        Retry
      </Button>
    </Flex>
  );
};

const QueryBoundary = ({ children, errorFallback, loadingFallback }: QueryBoundaryProps) => {
  const { reset } = useQueryErrorResetBoundary();

  return (
    <ErrorBoundary fallback={errorFallback || <DefaultErrorFallback />} resetQuery={reset}>
      <Suspense fallback={loadingFallback || <></>}>{children}</Suspense>
    </ErrorBoundary>
  );
};

export default QueryBoundary;
